
import { MainCharityLotsModel } from '../models/MainCharityLotsModel.js';
import { MainCharityLotsView } from '../views/MainCharityLotsView.js';

export class MainCharityLotsController {
    constructor() {

        this.model = new MainCharityLotsModel();
        this.view = new MainCharityLotsView();

        this.model.subscribe(state => this.view.render(state));
    }
}